/**
 * lib/pipes.js — Iter 51 client helpers for Pipe Runs.
 */
import { api } from "@/lib/api";

export async function listSheetPipes(sheetId) {
  try {
    const { data } = await api.get(`/sheets/${sheetId}/pipes`);
    return data?.pipes || [];
  } catch {
    return [];
  }
}

export async function getPipe(pipeId) {
  const { data } = await api.get(`/pipes/${pipeId}`);
  return data;
}

export async function createPipe(sheetId, payload) {
  const { data } = await api.post(`/sheets/${sheetId}/pipes`, payload);
  return data;
}

export async function updatePipe(pipeId, patch) {
  const { data } = await api.patch(`/pipes/${pipeId}`, patch);
  return data;
}

export async function deletePipe(pipeId) {
  await api.delete(`/pipes/${pipeId}`);
}

export const PIPE_MATERIALS = [
  "RCP", "HDPE", "PVC", "DI", "CMP", "VCP", "FRP",
  "steel", "copper", "other",
];

export function formatPipeStation(pipe) {
  if (!pipe?.station_start || !pipe?.station_end) return null;
  return `STA ${stationLabel(pipe.station_start)} → ${stationLabel(pipe.station_end)}`;
}

function stationLabel(s) {
  if (s == null) return "—";
  const block = Math.floor(s / 100);
  const rem = s - block * 100;
  if (Math.abs(rem - Math.round(rem)) < 0.05) {
    return `${block}+${String(Math.round(rem)).padStart(2, "0")}`;
  }
  return `${block}+${rem.toFixed(2).padStart(5, "0")}`;
}
